import { HTMLAttributes } from 'react'

export function Paper({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
	return <div className={`bg-white rounded-xl border border-slate-200 ${className}`} {...props} />
}
